import { render } from "./Setting.vue?vue&type=template&id=e9dd895a&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=e9dd895a&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9dd895a"]])

export default __exports__